document.addEventListener("turbolinks:load", function () {
  // let currentSlide = 0;

  (() => {
    let contactBtn = document.getElementById("product-contact");
    let contactForm = document.getElementById("product-contact-form");
    let closeFormBtn = document.getElementById("contact-form-close");

    if (!contactBtn || !contactForm) return;

    contactBtn.onclick = () => {
      contactForm.classList.remove("hide");
      document.body.classList.add("no-scroll");
    };

    contactForm.onclick = (event) => {
      if (event.target.id == "product-contact-form") {
        closeModal();
      }
    };

    closeFormBtn.onclick = () => {
      closeModal();
    };

    function closeModal() {
      contactForm.classList.add("hide");
      document.body.classList.remove("no-scroll");
    }
  })();

  // Product gallery
  /* 
  
  (() => {
    const thumbEls = document.querySelectorAll(".thumbs .g-image");
    const slidesEl = document.querySelector("._slides");

    if (thumbEls.length == 0 || !slidesEl) return;

    thumbEls.forEach((el) => {
      el.onclick = () => {
        let index = parseInt(el.dataset.index);

        showSlide(index);
      };
    });

    const observer = new ResizeObserver(() => {
      showSlide(currentSlide); // Adjust the slider position on resize
    });
    observer.observe(slidesEl);

    function showSlide(index) {
      const slideEls = document.querySelectorAll(".slides .g-image");

      if (slideEls.length == 0) return;

      let slidesWidth = slidesEl.getBoundingClientRect().width;

      slideEls[currentSlide].classList.remove("active");
      thumbEls[currentSlide].classList.remove("active");

      slidesEl.style.transform = `translateX(${-index * slidesWidth}px)`;

      currentSlide = index;

      slideEls[currentSlide].classList.add("active");
      thumbEls[currentSlide].classList.add("active");
    }
  })();
  
  */

  // Product gallery
  (() => {
    if (!document.querySelector("#product .gallery")) return;

    const thumbSwiper = new Swiper("#product .thumbs", {
      loop: true,
      spaceBetween: 12,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesProgress: true
    });

    const swiper = new Swiper("#product .main", {
      delay: 2500,
      speed: 400,
      spaceBetween: 12,
      loop: true,
      thumbs: {
        swiper: thumbSwiper,
      },
    });
    swiper.autoplay.start();
  })();

  // Sm menu
  (() => {
    let smMenuEl = document.getElementById("sm-menu");
    let smMenuItemsEl = document.getElementById("sm-menu-items");
    let smMenuCloseEl = document.querySelector("#sm-menu-items .close");

    if (!smMenuEl || !smMenuItemsEl || !smMenuCloseEl) return;

    smMenuEl.onclick = () => {
      smMenuItemsEl.classList.remove("hide");
    };

    smMenuCloseEl.onclick = () => {
      smMenuItemsEl.classList.add("hide");
    };
  })();

  // Cancel search
  (() => {
    let searchFormEl = document.querySelector(".search-form");

    if (!searchFormEl) return;

    let selectEl = searchFormEl.querySelector("select");
    let searchEl = searchFormEl.querySelector("input[type=search]");
    let submitBtnEl = searchFormEl.querySelector("[type=submit]");
    let cancelBtnEl = searchFormEl.querySelector(".cancel");

    if (!submitBtnEl || !cancelBtnEl) return;

    if (selectEl) {
      selectEl.onchange = () => {
        submitBtnEl.click();
      };
    }

    cancelBtnEl.onclick = () => {
      if (selectEl) {
        selectEl.value = "";
      }

      if (searchEl) {
        searchEl.value = "";
      }

      submitBtnEl.click();
    };
  })();

  // Banner
  (() => {
    if (!document.querySelector("#home .banner") || !document.querySelector("#home .mini-banner")) return;

    const swiper = new Swiper("#home .banner", {
      delay: 2500,
      speed: 400,
      loop: true,
      allowTouchMove: false
    });
    swiper.autoplay.start();

    const miniSwiper = new Swiper("#home .mini-banner", {
      delay: 2500,
      speed: 400,
      loop: true,
      allowTouchMove: false,
      pagination: {
        el: '.dots',
      },
    });
    miniSwiper.autoplay.start();
  })();

  // Return to top
  (() => {
    const returnBtn = document.getElementById("return-top");

    if (!returnBtn) return;

    returnBtn.onclick = () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  })();

  // Header on scrolling
  window.onscroll = () => {
    const headerEl = document.querySelector("#lg-header ._menu");
    const smHeaderEl = document.querySelector("#sm-header ._menu");
    const navEl = document.querySelector("#abouts .nav");
    const returnTopEl = document.getElementById("return-top");

    if (document.body.scrollTop > 300 || document.documentElement.scrollTop > 300) {
      if (headerEl) headerEl.classList.add("fixed");
      if (smHeaderEl) smHeaderEl.classList.add("fixed");
      if (navEl) navEl.classList.add("fixed");
      if (returnTopEl) {
        returnTopEl.classList.remove("hide");
        returnTopEl.classList.add("show");
      }
    } else {
      if (headerEl) headerEl.classList.remove("fixed");
      if (smHeaderEl) smHeaderEl.classList.remove("fixed");
      if (navEl) navEl.classList.remove("fixed");
      if (returnTopEl) {
        returnTopEl.classList.remove("show");
        returnTopEl.classList.add("hide");
      }
    }
  }

  // Customers slide
  (() => {
    if (!document.querySelector(".swiper._container")) return;

    const swiper = new Swiper(".swiper._container", {
      slidesPerView: 2,
      spaceBetween: 16,
      delay: 2500,
      speed: 400,
      loop: true,
      navigation: {
        nextEl: '#home .customers ._next',
        prevEl: '#home .customers ._prev',
      },
      breakpoints: {
        1024: {
          slidesPerView: 5
        }
      }
    });
    swiper.autoplay.start();
  })();

  // Header search
  (() => {
    const searchEl = document.querySelector("#lg-header .search ._button");

    if (!searchEl) return;

    searchEl.onclick = () => {
      const formEl = document.querySelector("#lg-header .search .form");
      if (!formEl) return;

      if (formEl.classList.contains("hide")) {
        formEl.classList.remove("hide");
      } else {
        formEl.classList.add("hide");
      }
    }
  })();

  // Contact popup
  (() => {
    const modalOverlayEl = document.querySelector(".contact-fm-overlay");
    const headerCloseEl = document.querySelector(".contact-fm ._header .close");
    const footerCloseEl = document.querySelector(".contact-fm ._body .close");

    if (!modalOverlayEl) return;

    const closeModal = function () {
      modalOverlayEl.classList.add("hide");
    }

    modalOverlayEl.onclick = e => {
      const target = e.target;
      if (target.classList.contains("contact-fm-overlay")) closeModal();
    }

    headerCloseEl.onclick = () => {
      closeModal();
    }

    footerCloseEl.onclick = () => {
      closeModal();
    }
  })();

  // Products category bar
  (() => {
    const currentSearch = window.location.search;

    if (currentSearch == '') return;
    const searchId = parseInt(currentSearch.split("=").at(-1));

    if (!searchId) return;

    const catEl = document.querySelector(`#products .nav a[href*='${currentSearch}']`);
    const detailsEl = catEl.closest("details");

    if (!catEl) return;

    catEl.classList.add("active");
    detailsEl.setAttribute("open", true);
  })();

  // Header level 3 menu items
  (() => {
    const itemEls = document.querySelectorAll("#lg-header .menu-items ._submenu>._link");

    itemEls.forEach(el => {
      el.onclick = () => {
        const url = el.dataset.url;

        window.location.href = url;
      }
    });
  })();
});
